import type React from "react"

// The one card/panel surface every Global Map tab renders on — the map
// rectangle, the KPI tiles, the details column, Recent Activity, and every
// Analytics card. Map, List and Analytics are three views of one feature, so
// they share this rather than each spelling out its own border/radius/shadow
// and drifting (the earlier `#E3E8EF` vs `gray-200` vs `slate-200` split this
// replaces).
//
// `slate-200` is `UI_UX_GUIDELINES.md` §3.1's own neutral ramp value
// (`#E2E8F0`), `rounded-lg` its §3.2 container radius (8px), and `shadow-card`
// the app-wide `--shadow-card` token `CardComponent` already uses.
export const GLOBAL_MAP_SURFACE_CLASS =
  "rounded-[10px] border border-[#E2E8F0] bg-white shadow-[0_4px_12px_rgba(15,23,42,0.06)]"

// §3.3's own trigger shadow, for the 36px-tall controls in the filter row —
// the picker triggers, the Lead/Project/History chips and "Look Around".
export const GLOBAL_MAP_CONTROL_SHADOW =
  "shadow-[0_2px_6px_rgba(15,23,42,0.06)]"

// Chart tooltips across the Analytics tab, so recharts' own default
// tooltip chrome reads as an EZBuild surface instead of a bare bordered box.
export const CHART_TOOLTIP_STYLE: React.CSSProperties = {
  borderRadius: 8,
  border: "1px solid #E2E8F0",
  boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)",
  fontSize: 12,
  padding: "6px 10px"
}

export const CHART_TOOLTIP_LABEL_STYLE: React.CSSProperties = {
  color: "#64748B",
  fontSize: 11,
  marginBottom: 2
}

// Axis ticks and grid lines, shared by the status bars and the trend lines so
// both charts read at the same weight.
export const CHART_AXIS_TICK = { fontSize: 11, fill: "#94A3B8" } as const
export const CHART_GRID_STROKE = "#F1F5F9"
